import styles from '@/modules/pipelines/components/deep-dive/pipeline-map-tabs.module.scss';
import AssetNavigator from '@/modules/pipelines/components/deep-dive/asset-navigator/asset-navigator';

export default function AssetNavigatorPanel() {
  return (
    <div className={styles.page}>
      <AssetNavigator />
    </div>
  );
}
